export default "__VITE_ASSET__GWa08BIU__"